import React from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';

const ProfileLoader = () => (
  <ContentLoader
    width={24}
    height={24}
    viewBox="0 0 24 24"
    style={{
      marginRight: 25,
    }}
  >
    <rect x="0" y="0" rx="100" ry="100" width="24" height="24" />
  </ContentLoader>
);

ProfileLoader.displayName = 'ProfileLoader';

export default ProfileLoader;
